<div>
  @if (form_headers.length) {
    @for (key of form_headers; track key) {
      <button (click)="scrollTo(key)"
        class="w-full p-4 border-b-2 flex justify-between items-center hover:bg-tw-lightgrey">
        <div class="flex">
          <span>{{ ('FORM.HEADS.' + (key | uppercase)) | translate }}</span>
          @if (hasRedDot(key)) {
            <mat-icon class="text-xs text-tw-secondary">fiber_manual_record</mat-icon>
          }
        </div>
        <span>
          <!-- <mat-icon class="tooltip-list" *ngIf="hasError(key) > 0" [color]="'warn'" matTooltipClass="tooltip-list" [matTooltip]="hasError(key) + ' ' + ('ERROR_FORM' | translate) + '\n' + getErrorTooltip(key)">warning</mat-icon> -->
          @if (hasError(key) > 0) {
            <div matTooltipPosition="right" matTooltipClass="tooltip-list"
              [matTooltip]="hasError(key) + ' ' + ('ERROR_FORM' | translate) + '\n' + getErrorTooltip(key)">
              <mat-icon [color]="'warn'">warning</mat-icon>
            </div>
          }
          @if (hasWarning(key) > 0 && !(hasError(key) > 0)) {
            <div matTooltipPosition="right"
              matTooltipClass="tooltip-list"
              [matTooltip]="hasWarning(key) + ' ' + ('WARNING_FORM' | translate) + '\n' + getWarningTooltip(key)">
              <mat-icon class="mat-warn-yellow">warning</mat-icon>
            </div>
          }
          @if ((isSubFormValid(key) && !isFormEmpty(key))) {
            <mat-icon
            [color]="'primary'">check_circle</mat-icon>
          } @else {
            <mat-icon outline>check_circle_outline</mat-icon>
          }
        </span>
      </button>
    }
  } @else {
    @if (isFormGroup(form)) {
      <div class="w-full p-4 border-b-2 flex justify-between items-center">
        <span>{{ 'FORM.' + (name() | uppercase) | translate }}</span>
        <span>
          @if (hasError() > 0) {
            <mat-icon [color]="'warn'"
            [matTooltip]="hasError() + ' ' + ('ERROR_FORM' | translate)">warning</mat-icon>
          }
          <!-- form.valid, not isFormValid(): that one re-runs the validation and emits valid$ and
          valueChanges, which write signals while the view is being checked (NG0600) -->
          @if (form.valid) {
            <mat-icon [color]="'primary'">check_circle</mat-icon>
          } @else {
            <mat-icon outline>check_circle_outline</mat-icon>
          }
        </span>
      </div>
    }
  }
</div>
